import script from "./Home-big.vue?vue&type=script&setup=true&lang=js"
export * from "./Home-big.vue?vue&type=script&setup=true&lang=js"

import "./Home-big.vue?vue&type=style&index=0&id=490a61d5&lang=css"
import "./Home-big.vue?vue&type=style&index=1&id=490a61d5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-490a61d5"]])

export default __exports__